export default "__VITE_ASSET__1a5f48e9__"